import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "@/config/firebase";
import type { GetStudiomateCounselsResponse } from "@vlab-corporation/studiomate-api";

export async function fetchStudiomateCounsels(params: {
  startDate: string;
  endDate: string;
}): Promise<GetStudiomateCounselsResponse> {
  const fn = httpsCallable<{ startDate: string; endDate: string }, GetStudiomateCounselsResponse>(
    getFirebaseFunctions(),
    "getStudiomateCounsels",
  );

  const result = await fn(params);
  return result.data;
}
